
const baseUrlGLPI = process.env.REACT_APP_BASE_GLPI_API


const apiGLPIRoutes = {
    computerGetAll: `${baseUrlGLPI}/computer?range=0-9999`,
    phoneGetAll:`${baseUrlGLPI}/phone?range=0-9999`,
    monitorGetAll:`${baseUrlGLPI}/monitor?range=0-9999`,
    computerPut: `${baseUrlGLPI}/computer/:materielId`,
    phonePut:`${baseUrlGLPI}/phone/:materielId`,
    monitorPut:`${baseUrlGLPI}/monitor/:materielId`,
    documentGetOne:`${baseUrlGLPI}/Document/:documentId`,
    documentPostOne: `${baseUrlGLPI}/Document`

   }

export default apiGLPIRoutes;